import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';

export const ProjectRfqsGraphStyles = css`
  ${MainStyles}

  .container {
    width: 100%;
  }

  .periodicity-control {
    width: 250px;
    padding-left: 15px;
  }

  .custom-segmented-item {
    margin: 0;
    height: 28px;
    padding: 0;
  }

  .criteria-selection {
    padding-bottom: 12px;
    display: flex;
  }

  .control-label {
    color: var(--gray-lighter);
    font-size: 13px;
    font-weight: 700;
  }

  .graph-div {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .basket-div {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .basket-icon {
    padding: 0 5px;
  }

  .basket-text {
    font-family: roboto-regular, 'Segoe UI', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: normal;
    color: #ccc;
  }
`;
